import delegate from "delegate-it";
import ajax from "@/scripts/common/ajax";
import { scrollTo } from "@/scripts/common/scroll-to";

const setupSolutionItems = (el) => {
  const animatedList = el.querySelector(".printing-solution-items");
  const imageList = el.querySelector(".printing-solution-images");

  if (!animatedList || !imageList) {
    return;
  }

  const listItems = animatedList.querySelectorAll("li");
  const imageItems = imageList.querySelectorAll("li");

  if (!listItems.length || !imageItems.length) {
    return;
  }

  let isPaused = false;
  let currentIndex = 0;

  const listLinks = animatedList.querySelectorAll("a");
  const imageLinks = imageList.querySelectorAll("a");

  listLinks.forEach((link) => {
    link.addEventListener("mouseenter", () => {
      listItems[currentIndex].classList.remove("is-active");
      imageItems[currentIndex].classList.remove("is-active");
      currentIndex = parseInt(link.dataset.pos) - 1;
      listItems[currentIndex].classList.add("is-active");
      imageItems[currentIndex].classList.add("is-active");
      isPaused = true;
    });

    link.addEventListener("mouseleave", () => {
      isPaused = false;
    });
  });

  imageLinks.forEach((link) => {
    link.addEventListener("mouseenter", () => {
      isPaused = true;
    });

    link.addEventListener("mouseleave", () => {
      isPaused = false;
    });
  });

  setInterval(() => {
    if (isPaused) {
      return;
    }

    listItems[currentIndex].classList.remove("is-active");
    imageItems[currentIndex].classList.remove("is-active");
    currentIndex = (currentIndex + 1) % listItems.length;
    listItems[currentIndex].classList.add("is-active");
    imageItems[currentIndex].classList.add("is-active");
  }, 3000);
};

const handlePanelLoad = async (e) => {
  e.preventDefault();

  const link = e.delegateTarget;
  link.closest("ul").querySelector('[aria-selected="true"]').setAttribute("aria-selected", "false");
  link.setAttribute("aria-selected", "true");

  const panelHolder = document.querySelector("[data-page-content]");
  const panelUrl = new URL(link.href);
  panelUrl.searchParams.append("panel", "true");

  const loadingTimeout = setTimeout(() => {
    panelHolder.classList.add("is-loading");
  }, 300);

  const res = await ajax.get(panelUrl).text();

  clearTimeout(loadingTimeout);

  panelHolder.innerHTML = res;
  panelHolder.classList.remove("is-loading");

  scrollTo(panelHolder);

  setupSolutionItems(panelHolder);
};

document.addEventListener("DOMContentLoaded", () => {
  const solutionPanel = document.querySelector(".printing-solution-panel");

  if (solutionPanel) {
    setupSolutionItems(solutionPanel);

    delegate("#page-submenu a", "click", handlePanelLoad);
  }
});
